import { useState, useEffect } from 'preact/hooks';

const useCustomizerStyleModal = () => {
  const [isCustomizerStyleModalOpen, setIsCustomizerStyleModalOpen] = useState(false);
  const [isKidsGraphic, setIsKidsGraphic] = useState('False');
  const [isHoodieGraphic, setIsHoodieGraphic] = useState('False');
  const [isTankGraphic, setIsTankGraphic] = useState('False');
  const [customizerBackgroundImgUrl, setCustomizerBackgroundImgUrl] = useState('');

  // stores the selected graphic data and opens the customizer style modal
  const openCustomizerStyleModal = (event) => {
    event.preventDefault();

    document.body.style.overflow = 'hidden';

    const kidsGraphic = event.currentTarget.getAttribute('data-is-kids-graphic');
    const hoodieGraphic = event.currentTarget.getAttribute('data-is-hoodie-graphic');
    const tankGraphic = event.currentTarget.getAttribute('data-is-tank-graphic');
    const backgroundImgUrl = event.currentTarget.getAttribute('data-customizer-background-img-url') || '';

    // PDP customizer button
    let graphicName = event.currentTarget.getAttribute('data-graphic-name');

    // Customizer PLP product card
    if (!graphicName) {
      graphicName = event.currentTarget?.nextElementSibling?.querySelector('.ns-product-name')?.textContent || '';
    }

    // Default PLP product card customizer icon
    if (!graphicName) {
      graphicName =
        event.currentTarget?.parentElement?.querySelector('.ns-product-info')?.querySelector('.ns-product-name')
          ?.textContent || '';
    }

    // Remove tee type from graphic name
    if (graphicName) {
      graphicName = graphicName?.split('Short Sleeve')[0]?.trim();
      graphicName = graphicName?.split('Long Sleeve')[0]?.trim();
    }

    setIsKidsGraphic(kidsGraphic);
    setIsHoodieGraphic(hoodieGraphic);
    setIsTankGraphic(tankGraphic);
    setCustomizerBackgroundImgUrl(backgroundImgUrl.trim());
    setIsCustomizerStyleModalOpen(true);

    localStorage.setItem('gan', event.currentTarget.getAttribute('data-gan'));
    localStorage.setItem('isKidsGraphic', kidsGraphic);
    localStorage.setItem('isHoodieGraphic', hoodieGraphic);
    localStorage.setItem('isTankGraphic', tankGraphic);
    localStorage.setItem('customizerBackgroundImgUrl', backgroundImgUrl.trim());
    localStorage.setItem('graphicName', graphicName);
  };

  // add event listeners to default product card customizer icon and pdp customizer button (required for Nosto)
  useEffect(() => {
    const addEventListeners = () => {
      const buttons = document.querySelectorAll('.customizer-button');
      buttons.forEach((button) => {
        button.addEventListener('click', openCustomizerStyleModal);
      });
    };

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          addEventListeners();
        }
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    addEventListeners();

    return () => {
      observer.disconnect();
      const buttons = document.querySelectorAll('.customizer-button');
      buttons.forEach((button) => {
        button.removeEventListener('click', openCustomizerStyleModal);
      });
    };
  }, []);

  // add event listeners to customizer product card (required for Nosto)
  useEffect(() => {
    const addEventListeners = () => {
      const productCards = document.querySelectorAll('.customizer-product-card');
      productCards.forEach((productCard) => {
        productCard.addEventListener('click', openCustomizerStyleModal);
      });
    };

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          addEventListeners();
        }
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    addEventListeners();

    return () => {
      observer.disconnect();
      const productCards = document.querySelectorAll('.customizer-product-card');
      productCards.forEach((productCard) => {
        productCard.removeEventListener('click', openCustomizerStyleModal);
      });
    };
  }, []);

  // close the customizer style modal
  const closeCustomizerStyleModal = () => {
    setIsCustomizerStyleModalOpen(false);

    document.body.style.overflow = 'auto';
  };

  // close the customizer style modal when the escape key is pressed
  const handleEscape = (event) => {
    if (event.key === 'Escape') {
      closeCustomizerStyleModal();
    }
  };

  // add event listener for the escape key
  useEffect(() => {
    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, []);

  return {
    isCustomizerStyleModalOpen,
    isKidsGraphic,
    isHoodieGraphic,
    isTankGraphic,
    customizerBackgroundImgUrl,
    openCustomizerStyleModal,
    closeCustomizerStyleModal,
  };
};

export default useCustomizerStyleModal;
